export function fmt(n, locale = 'de-DE') {
  if (Math.abs(n) < 0.01) return n.toFixed(6);
  return n.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// EUR-Anzeige: immer 2 Nachkommastellen, kein Mikro-Fallback.
export function fmtEur(n, locale = 'de-DE') {
  return (Number(n) || 0).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtC(n, locale = 'de-DE') {
  if (n < 0.001) return n.toFixed(6);
  return n.toLocaleString(locale, { maximumFractionDigits: 4 });
}

export function fmtPct(n) {
  const sign = n >= 0 ? '+' : '';
  return `${sign}${n.toFixed(2)}%`;
}
